import { render, staticRenderFns } from "./DouMaiKeJiShiChangTuBiao.vue?vue&type=template&id=181d7076&scoped=true&"
import script from "./DouMaiKeJiShiChangTuBiao.vue?vue&type=script&lang=js&"
export * from "./DouMaiKeJiShiChangTuBiao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181d7076",
  null
  
)

export default component.exports